import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,
  ReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "party-tab",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./seasontarget.component.html",
})
export class SeasonTargetReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  isLoadMask: Promise<any>;
  seasonList = [];
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearCtrl: FormControl = new FormControl();
  finyearList = [];
  gridOptions: any;
  exceldata: any;
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "season",
    orderDir: "asc",
  };

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  columns = [];
  toggleCol = [];

  filterExpand = false;
  filterData: any = {
    fin_id: 3,
    //company_id: 0
  };
  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private combo: Combo2Service,
    private reportService: ReportService,
    private excelService: ExcelService,
    public toasterService: ToasterService
  ) {
    /*   this.companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
           this.filterData.company_id = this.companyInfo.id;*/
  }
  printConfig: any = {
    title: "Seasonal Target report",
    columns: [],
    rows: [],
  };
  ngOnInit(): void {
    this.columns = [
      //{ width: 30, sortable: false, canAutoResize: false, draggable: false, resizeable: false, headerCheckboxable: false, checkboxable :true},
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        summaryFunc: (cells) => "Sample",
        type: "sno",
      },
      //{ name: 'Fin Year', prop: 'finyear', minWidth: 150, maxWidth: 150, width: 150 },
      {
        name: "Season",
        prop: "season",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
      {
        name: "Target Qty",
        cellClass: "txtRight",
        prop: "order_target",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        summary: "sum",
      },
      {
        name: "Order Qty",
        cellClass: "txtRight",
        prop: "totqty",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
        summary: "sum",
      },
      {
        name: "Diff Qty",
        cellClass: "txtRight",
        prop: "order_diff",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
        summary: "sum",
      },
      //  { name: 'Sales To Date', prop: 'sales_to_f', minWidth: 120, maxWidth: 120, width: 120 },
      // { name: 'Action', prop: 'sno', minWidth: 100, maxWidth: 100, width: 100, sortable: false, cellTemplate: this.editDeleteTemplate }
    ];
    this.LoadFinYearList();

    this.toggleCol = Object.assign({}, this.columns);
    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    //this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
      if (event.ctrl && event.keyCode === 13) {
        //this.addEditSeason('Add', '');
      }
      if (event.keyCode === 27) {
        // this.bsModalRef.hide();
      }
    }
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterpartyName").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getSeasonTargetList();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSeasonTargetList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getSeasonTargetList();
  }

  getSeasonTargetList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      // name:this.filterData.name,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: this.filterData.fin_id,
      // tabTitle: this.title
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getSeasonTargetList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        //  that.page.count = res.data.length;
        //  that.seasonList = res.data;
        that.gridOptions = {
          columns: that.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Season Target report",
          columns: that.columns,
          rows: that.seasonList,
        };
        that.refreshData();
        that.exceldata = that.getData(res.columns, res.data);
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  LoadFinYearList() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      let fin = res.data[0];
      this.filterData.fin_id = fin["fin_id"];
      this.finyearCtrl.setValue(fin["fin_id"]);
      this.applyFilter();
    });
  }

  clearFilter(): void {
    this.filterData = {
      fin_id: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getSeasonTargetList();
  }

  refreshData() {
    let columns = this.columns,
      data = this.seasonList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getRowClass(event) {
    return event.type == "summary" ? "summary-row" : "";
  }
  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SeasonTargetReport/seasontarget.component.ts